/* eslint-disable react/jsx-no-literals */
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { useAccount } from '@/contexts/account-context';
import useLogout from '@/features/authentication/api/useLogout';
import Button from '@/features/ui/components/Button/Button';

const Unauthorized = () => {
  const { t } = useTranslation();
  const { mutateAsync } = useLogout();
  const account = useAccount();

  return (
    <LoaderWrapper>
      {account && (
        <Column>
          <LoggedInTitle>{t('unauthorized.logged_in_as')}</LoggedInTitle>
          <Text>
            {account.firstName} {account.lastName} - {account.email}
          </Text>
        </Column>
      )}
      <UnauthorizedTitle>{t('unauthorized.title')}</UnauthorizedTitle>
      <Button label={t('unauthorized.return')} variant="action" onClick={() => mutateAsync()} />
    </LoaderWrapper>
  );
};

const Column = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 1rem;
  margin: 1rem 0;
`;

const Text = styled.p`
  font-size: 1.5rem;
  font-weight: 500;
`;

const LoaderWrapper = styled.div`
  height: 100vh;
  height: 100dvh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  flex-direction: column;
  gap: 2rem;
`;

const LoggedInTitle = styled.h3`
  font-size: 2rem;
  text-align: center;
  font-weight: 500;
`;

const UnauthorizedTitle = styled.h2`
  font-size: 2rem;
  text-align: center;
`;

export default Unauthorized;
